import React from "react";
import { motion } from "framer-motion";

const TESTIMONIALS = [
  {
    id: "t1",
    quote:
      "A wonderful, interactive way to teach kids about money — story and colourful illustration on one page, real practice on the next. It breaks down saving and spending into small lessons our little one loved trying out on trips to the grocery store. A fantastic addition to any child's bookshelf.",
    name: "Arpita",
    role: "Architect · Parent",
  },
  {
    id: "t2",
    quote:
      "I use these in my Grade 2 classroom every Friday. The activities are the perfect bridge between story-time and a real conversation about needs and wants.",
    name: "James Whitfield",
    role: "Primary School Teacher · Manchester",
  },
  {
    id: "t3",
    quote:
      "Finally a book series that talks to children like they can understand — because they can. Warm illustrations, honest words, and no talking down.",
    name: "Dr. Priya Menon",
    role: "Child Development Researcher",
  },
  {
    id: "t4",
    quote:
      "We read one chapter, then did the activity together. It felt less like a lesson and more like something we discovered as a family.",
    name: "Marcus Alvarez",
    role: "Parent · Toronto",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      className="section"
      style={{ background: "var(--paper-warm)" }}
      data-testid="testimonials-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
          className="grid grid-cols-12 gap-6 md:gap-10 items-end mb-16 md:mb-20"
        >
          <div className="col-span-12 md:col-span-4">
            <p className="folio-num">Reader Letters · Marginalia</p>
          </div>
          <h2
            className="col-span-12 md:col-span-8 font-serif text-4xl sm:text-5xl md:text-6xl leading-[0.95] tracking-tight"
            data-testid="testimonials-heading"
          >
            What parents, teachers &amp; little readers are <em className="italic" style={{ color: "var(--accent-orange)" }}>saying.</em>
          </h2>
        </motion.div>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <motion.article
              key={t.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.08, duration: 0.9, ease: [0.2, 0.8, 0.2, 1] }}
              className="col-span-12 md:col-span-6 relative bg-[color:var(--paper)] border border-stone-900/12 p-8 md:p-10 flex flex-col"
              data-testid={`testimonial-${t.id}`}
            >
              <span
                aria-hidden="true"
                className="absolute -top-4 left-8 font-serif italic leading-none select-none"
                style={{
                  fontSize: "6rem",
                  color: "var(--accent-orange)",
                  lineHeight: 0.6,
                }}
              >
                &ldquo;
              </span>

              <p className="folio-num relative z-10">Letter № {String(i + 1).padStart(2, "0")}</p>

              <p
                className="mt-6 font-serif text-2xl md:text-[26px] leading-snug text-stone-800 flex-1"
                data-testid={`testimonial-quote-${t.id}`}
              >
                {t.quote}
              </p>

              <div className="mt-8 pt-6 border-t border-stone-900/12">
                <p
                  className="font-serif text-xl md:text-2xl leading-tight"
                  data-testid={`testimonial-name-${t.id}`}
                >
                  {t.name}
                </p>
                <p
                  className="mt-1 text-[11px] uppercase tracking-[0.28em] text-stone-500"
                  data-testid={`testimonial-role-${t.id}`}
                >
                  {t.role}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
